/*global jQuery */
(function($, window) {
  'use strict';

  $('.js-scrolltotop').on('click', function(e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop : 0
    }, 500);
  });
}(jQuery, window));
